export default __webpack_public_path__ + "static/image5-d26581554925fb48ec113b5eb74cec70.jpg";